import {
    $unAuthUser,
    $secureNowUser,
    $authUser
} from "@/plugins/axios";
import {
    getUser,
    getUserInfo,
    checkEmails,
    getFailedLogins,
    alertFailedSnAttempt,
    getConfig,
    getDocuments,
    getUserDetails,
    getUserByEmail
} from "@/graphql/queries";
import {
    updateUserAtts,
    updateUserPassword,
    respondToChallenge,
    createUserLog,
    updateMyProfile
} from "@/graphql/mutations";
import {
    API,
    Auth,
    Hub
} from "aws-amplify";
import qs from "qs";
import request from "request";
import router from "../../router";
import { $vueMoment } from "@/plugins/moment"

const state = {
    user: "",
    userDetails: "",
    currentPath: "",
    systemAdmin: false,
    state: "",
    loading: false,
    mainLoading: false,
    confirmed: false,
    mfa: false,
    awsMfa: false,
    box: "",
    sn: false,
    snAnswer: false,
    snMfa: true,
    phones: [],
    answer: {},
    snError: false,
    authError: "",
    failed: false,
    isNewUser: "",
    isNewPhone: "",
    admin: false,
    links: [],
    wexLinks: [],
    password: "",
    adminReset: false,
    termsDate: "2019-07-01T01:00:00.000Z",
    resetUser: "",
    retirementBranded: false,
    mersBranded: false,
    retirementBrandedTitle: "Retirement Account Access",
    mersBrandedTitle: "MERS Account Access",
    step: 1,
    print: false,
    wex: false,
    mobileSignup: false,
    straightSso: false,
    snPhones: [],
    userAccounts: [],
    docTypes: [],
    currDocTypes: [],
    userStatements: [],
    config: "",
    vendor: "",
    lastReview: false,
    reviewMode: false,
    hub: false
};

const getters = {
    isAuthenticated(state) {
        return !!state.user
    }
};

const actions = {
    async checkUser({ dispatch, commit }, route) {
        let result
        commit("setMainLoading", true)
        try {
            let user = await Auth.currentAuthenticatedUser({
                bypassCache: true
            });
            commit("setUser", user)
            await dispatch("checkProperty", route)            
            result = true
        } catch (error) {
            dispatch("signOut")
            result = false
        }
        commit("setMainLoading", false)
        return result
    },
    async signOut({ commit }) {
        Auth.signOut()
        commit("setState", "signedOut")
        commit("setSN", false)
        commit("setSNAnswer", false)
        commit("emptyUser")
        commit("unsetConfirmed")
        commit("setState", "signedOut")
        commit("setError", false)
        commit("setLoading", false)
        commit("setAnswer", "")
        commit("setPhones", [])
        commit("setLinks", [])
        commit("setAWSMfa", false)
    },
    async checkConfig({
        state,
        commit,
        dispatch
    }) {
        const {
            data: {
                data
            }
        } = await $unAuthUser.post(
            "/", {
                query: getConfig
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
            );
        commit("setConfig", data.getConfig)
        dispatch("checkDocuments", state.mersBranded ? "MERS" : "Alerus")
        // commit("setDocumentTypes", data.getConfig.docTypes.map(item => item.name))
        return data.getConfig
    },
    async checkDocuments({
        state,
        commit
    }, lob) {
        const {
            data: {
                data
            }
        } = await $unAuthUser.post(
            "/", {
                query: getDocuments,
                variables: {
                    lob
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
            );
        commit("setDocumentTypes", data.getDocuments)
    },
    async checkForAdminUser({
        state,
        dispatch,
        commit
    }, { system, target }) {
        let { maintenance } = await dispatch("checkConfig")
        await dispatch("getSystem", {
            maintenance,
            system,
            target
        });
    },
    async checkReview({ 
        state,
        commit
    }) {
        let mers = state.user.attributes["custom:userFlags"] ? JSON.parse(state.user.attributes["custom:userFlags"]).isMERS : false
        let adminUser = state.user.attributes["custom:userFlags"] ? JSON.parse(state.user.attributes["custom:userFlags"]).isAdmin : false
        let wexAdmin = state.user.attributes["custom:userFlags"] ? JSON.parse(state.user.attributes["custom:userFlags"]).isWexFLXAdmin : false
        if (adminUser || wexAdmin) {
            commit("setSystemAdmin", true)
        }
        if (!state.systemAdmin && !mers) {
            if (!state.userDetails.lastReview) {
                commit("setLastReview", true)
                commit("setCurrentPath", router.currentRoute.path)
                router.push("/myaccount")
                return true
            }
            else {
                let currDate = $vueMoment()
                let lastDate = $vueMoment(state.userDetails.lastReview)
                let diff = currDate.diff(lastDate, "months")
                if (diff >= 6) {
                    commit("setLastReview", true)
                    commit("setCurrentPath", router.currentRoute.path)
                    router.push("/myaccount")
                    return true
                }
                else return false
            }
        }
        else return false
    },
    async getSystem({
        state,
        commit,
        dispatch
    }, { maintenance, system, target }) {
        let url = `/getSystemLink?maintenanceMode=${maintenance}`
        if (system && system !== "none") url = url + `&system=${system}`
        if (target) url = url + `&target=${target}`
        let {
            data
        } = await $authUser.get(url, {
            headers: {
                Authorization: `Bearer ${state.user.signInUserSession.idToken.jwtToken}`
            }
        });
        
        if (data.isAdmin || data.isWexFLXAdmin) {
            commit("setSystemAdmin", true)
        }
        
        // SSO user directly to MyAlerus, regardless of multiple SSO options
        if (router.currentRoute.query.sso === "true") {
            commit("setStraightSso", true);
        }

        // Route user appropriately after sign in
        if (router.currentRoute.fullPath === "/signup?mobileapp=true" ||
            router.currentRoute.fullPath === "/resetpassword?mobileapp=true") {
            // User came from mobile app, direct them back there
            commit("setConfirmed");
            commit("setMobileSignup", true);
        } else if (router.currentRoute.name !== "account") {
            // Build SSO links
            if (data.isAdmin || data.isWexFLXAdmin) {
                // Build links for Plan Sponsor
                commit("setConfirmed");
                commit("setAdmin", true);
                let links = [];
                data.adminLinks.forEach(function (link) {
                    links.push({
                        label: link.label,
                        url: link.target,
                        target: ""
                    });
                });
                commit("setLinks", links);
            } else if (data.system === "wex" || data.system === "wex-flx") {
                // Build links for HSA user
                let links = [];
                if (!state.config.maintenance && !data.system === "wex-flx") {
                    links.push({
                        label: "My Alerus",
                        url: data.myAlerusLink,
                        target: ""
                    });
                    // If user has more than one HSA, show all of them
                    if (data.wexLinks.length > 1) {
                        data.wexLinks.forEach(function (link) {
                            links.push({
                                label: link.name + " Health Benefits",
                                url: link.url,
                                target: "_blank"
                            });
                        });
                    } else {
                        // Otherwise, show default HSA link
                        links.push({
                            label: "Alerus Health Benefits",
                            url: data.wexLinks[0].url,
                            target: "_blank"
                        });
                    }
                } else {
                    console.log("MyAlerus Maintenance");
                    [].concat(data.maintenanceLinks, data.wexLinks).forEach(function (link) {
                        links.push({
                            label: link.name,
                            url: link.url,
                            target: ""
                        });
                    });
                }

                commit("setWex", true);
                commit("setConfirmed");
                commit("setLinks", links);
            } else if (data.system == "multiple") {
                let links = [];
                if (!state.config.maintenance) {
                    links.push({
                        label: "My Alerus",
                        url: data.myAlerusLink,
                        target: ""
                    });
                } else {
                    console.log("MyAlerus Maintenance");
                    [].concat(data.maintenanceLinks, data.wexLinks).forEach(function (link) {
                        links.push({
                            label: link.name,
                            url: link.url,
                            target: ""
                        });
                    });
                }
                data.consumerLinks.forEach(function (link) {
                    links.push({
                        label: link.name,
                        url: link.url,
                        target: ""
                    })
                });
                commit("setConfirmed");
                commit("setLinks", links);
            } else {
                // User only has one HSA target, direct SSO them to next hop
                if (state.config.maintenance && data.system === "myalerus") {
                    // Don't SSO
                    let links = [];
                    console.log('under maintenance');
                    [].concat(data.maintenanceLinks, data.wexLinks).forEach(function (link) {
                        links.push({
                            label: link.name,
                            url: link.url,
                            target: ""
                        });
                    });
                    commit("setLinks", links);
                    commit("setConfirmed");
                } else {
                    // console.log("SSO user");
                    window.location = data.systemLink;
                }

            }
        } else {
            commit("setConfirmed");
        }
    },
    async createLog({}, fullLog) {
        try {
            const {
                data
            } = await API.graphql({
                query: createUserLog,
                variables: {
                    username: fullLog.username,
                    log: fullLog.log,
                    app: fullLog.app,
                    info: fullLog.info
                },
                authMode: 'API_KEY'
            });
        } catch (error) {
            // console.log(error)
            return error
        }
    },
    async confirmUser({
        commit,
        state,
        dispatch
    }, { signIn = false } = {}) {
        // dont confirm user again if in review process
        if (state.lastReview || state.reviewMode) return
        // create successful sign in attempt log
        if (signIn) {
            dispatch("createLog", {
                username: state.user.username,
                log: "SignIn",
                app: "MyAlerus",
            })
        }
        let refreshToken = state.user.signInUserSession.refreshToken
        let sn = state.user.signInUserSession.idToken.payload.snProcessingMFA
        if (process.env.VUE_APP_USE_SECURENOW === "false") {
            sn = "false"
        }
        if (sn !== "false") {
            // console.log(sn, "refresh token")
            let token = await new Promise(res => {
                state.user.refreshSession(refreshToken, (err, sess) => {
                    res(sess.idToken.jwtToken)
                })
            })
            await commit("setIdToken", token)
        }

        if (state.user.attributes["custom:alerus360id"]) {
            await dispatch("getUserDetails", JSON.stringify({
                a360id: state.user.attributes["custom:alerus360id"]
            }))
        }
        else {
            await dispatch("getUserDetails", JSON.stringify({
                a360id: state.user.attributes["custom:sponsor"]
            }))
        }
        
        await dispatch("checkReview")
    },
    async getBB({
        state
    }) {
        if (state.box) {
            return state.box;
        } else {
            return new Promise(resolve => {
                let unsubscribe = this.subscribe(mutation => {
                    if (mutation.type === "user/setBox") {
                        resolve(mutation.payload);
                        unsubscribe();
                    }
                });
            });
        }
    },
    async checkProperty({
        state,
        dispatch,
        commit
    }, route) {
        let flags = {};
        let system;
        let target;
        if (state.user.attributes.hasOwnProperty("custom:userFlags")) {
            flags = JSON.parse(state.user.attributes["custom:userFlags"]);
        } else {
          flags = {
            isAdmin: false,
            OCEAccess: false,
            CFUAccess: false,
            isWexFLXAdmin: false
          };
        }

        // check route query for system property
        if (route) {
            if (route.query.hasOwnProperty('system')) system = route.query.system
            if (route.query.hasOwnProperty('target')) {
                target = route.query.target
            }
        }

        // set route name
        if (!route) route = router.currentRoute.name
        else route = route.name
  
        if (
          state.user.attributes.hasOwnProperty("custom:alerus360id") ||
          flags.isAdmin ||
          flags.OCEAccess ||
          flags.CFUAccess ||
          flags.isWexFLXAdmin
        ) {
          if (await dispatch("checkBB")) {
            if (process.env.VUE_APP_USE_SECURENOW !== "false") {
              dispatch("checkSecureNowPhones");
            }
            if (
              route !== "account" &&
              route !== "documents"
            ) {
                await dispatch("checkForAdminUser", { system, target });
            } else commit("setConfirmed");
          } else {
            // Secure Now check user
            commit("setSN", true);
            console.log("checking user here 2");
          }
        }
        // else {
        //   this.getExtras = true;
        //   this.populateExtras();
        // }
    },
    async checkBB({
        dispatch,
        state,
        commit
    }, { signIn = false } = {}) {
        if (process.env.VUE_APP_USE_SECURENOW === "false" || state.awsMfa || state.mfa) {
            await dispatch("confirmUser", { signIn })
            return true;
        } else {
            let box = await dispatch("getBB");
            // let box = '';
            const {
                data
            } = await $authUser.post(
                `/SecureNow/LoginEvent`, {
                    BlackBox: box,
                    NumberOfFails: 0
                }, {
                    headers: {
                        Authorization: `Bearer ${
                            state.user.signInUserSession.idToken.jwtToken
                        }`
                    }
                }
            );
            let action = JSON.parse(data)["Action"];
            let phoneResponse = JSON.parse(data).Phones
            if (action === "Proceed") {
                await dispatch("confirmUser")
                return true
            } else if (action === "Challenge") {
                let phones = await dispatch("filterPhones", JSON.parse(data)["Phones"])
                commit("setPhones", phones);
                commit("setIsNewUser", JSON.parse(data)["IsNewUser"]);
                commit("setIsNewPhone", JSON.parse(data)["IsNewPhone"]);
            } else if (action === "Error") {
                commit("setError", true);
                commit("setSN", false);
                console.log(JSON.parse(data)["ErrorMessage"]);
            }
        }
    },
    filterPhones({}, phones) {
        return phones.map(item => {
            let digits = item.PhoneNumber.length - 4;
            let lastFour = item.PhoneNumber.slice(-4);
            let x = "x"
            item.PhoneNumber = `${x.repeat(digits)}${lastFour}`
            return item;
        });
    },
    async snChallenge({
        state,
        commit
    }, phone) {
        const {
            data
        } = await $authUser.post(
            `/SecureNow/VerifyPhone`, {
                PhoneID: phone.phone.PhoneID,
                NumberOfFails: 0,
                Method: phone.method === "text" ? "sms" : "voice",
                IsNewUser: state.isNewUser,
                IsNewPhone: phone.method === "text" ? !phone.phone.IsRegisteredForSMS : !phone.phone.IsRegisteredForIVR
            }, {
                headers: {
                    Authorization: `Bearer ${
            state.user.signInUserSession.idToken.jwtToken
          }`
                }
            }
        );
        let action = JSON.parse(data)["Action"];
        if (action === "Answer") {
            commit("setAnswer", JSON.parse(data));
            commit("setSNAnswer", true);
        } else {
            commit("setError", true);
            commit("setSN", false);
            console.log(JSON.parse(data)["ErrorMessage"]);
        }
    },
    async snValidate({
        state,
        commit,
        dispatch
    }, code) {
        const {
            data
        } = await $authUser.post(
            `/SecureNow/ValidateCode`, {
                PhoneID: state.answer.PhoneID,
                NumberOfFails: state.answer.NumberOfFails,
                ConversationID: state.answer.ConversationID,
                IsNewUser: state.answer.IsNewUser,
                Code: code,
                BlackBox: state.answer.IsNewUser == true ? state.box : "",
                CorrelationId: state.answer.CorrelationId
            }, {
                headers: {
                    Authorization: `Bearer ${
            state.user.signInUserSession.idToken.jwtToken
          }`
                }
            }
        );
        let action = JSON.parse(data)["Action"];
        let fails = JSON.parse(data)["NumberOfFails"]
        if (action === "Proceed") {
            console.log("user confirmed from securenow phone validation");
            // create successful SecureNow MFA log
            await dispatch("createLog", {
                username: state.user.username,
                log: "SecureNowMfa",
                app: "MyAlerus",
            });
            await dispatch("confirmUser")
            if (process.env.VUE_APP_USE_SECURENOW !== "false") {
                dispatch("checkSecureNowPhones");
            }
            commit("setSN", false);
            await dispatch("checkForAdminUser");
        } else if (action === "Challenge") {
            if (fails) {
                // create failed SecureNow MFA log
                dispatch("createLog", {
                    username: state.user.username,
                    log: "SecureNowMfaFail",
                    app: "MyAlerus",
                });
                dispatch("alertFailedAttempt", state.user.attributes.email)
                return "Failed challenge"
            } else {
                commit("setAnswer", "");
                commit("setSNAnswer", false);
                commit("setPhones", JSON.parse(data)["Phones"]);
                // commit("setFailed", true);
                return "First challenge"
            }

        } else if (action === "Error") {
            commit("setError", true);
            commit("setSN", false);
            console.log(JSON.parse(data)["ErrorMessage"]);
        }
    },
    async checkAllEmails({
        state
    }, userEmail) {
        const {
            data
        } = await $unAuthUser.post(
            "/", {
                query: checkEmails,
                variables: {
                    email: userEmail
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        return data.data.checkEmails;
    },
    async checkFailedAttempts({}, username) {
        try {
            const {
                data
            } = await API.graphql({
                query: getFailedLogins,
                variables: {
                    username
                },
                authMode: 'API_KEY'
            });
            return data.getFailedLogins
        } catch (error) {
            console.log(error)
            return error
        }
    },
    async alertFailedAttempt({}, email) {
        try {
            const {
                data
            } = await API.graphql({
                query: alertFailedSnAttempt,
                variables: {
                    email
                },
                authMode: 'API_KEY'
            });
            return data.alertFailedSNAttempt
        } catch (error) {
            console.log(error)
            return error
        }
    },
    async challengeResponse({
        state
    }, user) {
        const {
            data
        } = await $unAuthUser.post(
            "/", {
                query: respondToChallenge,
                variables: {
                    username: user.username,
                    password: user.password,
                    session: user.session
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        console.log(data)
    },
    async setBoxDetails({
        commit,
        dispatch
    }, details) {
        await commit("setBox", details);
        // dispatch("checkBB", details)
    },
    async updateUser({
        state,
        commit
    }, updatedAtts) {
        const {
            data
        } = await $unAuthUser.post(
            "/", {
                query: updateUserAtts,
                variables: {
                    accessToken: state.user.signInUserSession.accessToken.jwtToken,
                    newAtts: updatedAtts.newAtts
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        let keys = updatedAtts.newAtts.map(item => item.Name);
        let newUserAtts = data.data.updateUserAtts.UserAttributes;
        let errors = keys.filter(item => {
            return newUserAtts[item] !== updatedAtts[item];
        });

        let newObject = newUserAtts.map(item => {
            return {
                [item.Name]: item.Value
            };
        });
        let final = Object.assign({}, ...newObject);
        if (errors.length) {
            return "Error Saving Changes";
        } else commit("setUserAtts", final);
    },
    async updateUserAtt({
        state,
        commit
    }, updatedAtts) {
        const {
            data
        } = await $unAuthUser.post(
            "/", {
                query: updateUserAtts,
                variables: {
                    username: state.user.username,
                    accessToken: state.user.signInUserSession.accessToken.jwtToken,
                    newAtts: updatedAtts
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (!data.data.updateUserAtts.Username) return false;
        else return true;
    },
    async updateMyprofile({
        state,
        commit
    }, params) {
        try {
            const {
                data
            } = await $unAuthUser.post(
                "/", {
                    query: updateMyProfile,
                    variables: {
                        func: params.func,
                        arguments: params.arguments
                    }
                }, {
                    headers: {
                        Authorization: state.user.signInUserSession.idToken.jwtToken
                    }
                }
                );
            if (params.func === "editUser") {
                data.data.updateMyProfile.password = ""
                data.data.updateMyProfile.password2 = ""
                commit("setUserDetails", data.data.updateMyProfile)
            }
            return data.data.updateMyProfile
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async editLastReview({ state, commit }) {
        commit("setLastReview", false)
        commit("setReviewMode", true)
        return state.currentPath
    },
    async getUserDetails({
        state,
        commit
    }, params) {
        try {
            const {
                data
            } = await $unAuthUser.post(
                "/", {
                    query: getUserDetails,
                    variables: {
                        func: "getUserDetails",
                        arguments: params
                    }
                }, {
                    headers: {
                        Authorization: state.user.signInUserSession.idToken.jwtToken
                    }
                }
                );
            let allPhones = JSON.parse(data.data.getUserDetails.phones)
            // data.data.getUserDetails.phones = allPhones.items
            data.data.getUserDetails.password = ""
            data.data.getUserDetails.password2 = ""
            // data.data.getUserDetails.home = allPhones.items.find(item => item.type === "home")
            // data.data.getUserDetails.mobile = allPhones.items.find(item => item.type === "mobile")
            // data.data.getUserDetails.work = allPhones.items.find(item => item.type === "work")
            commit("setUserDetails", data.data.getUserDetails)
            return data.data.getUserDetails
        } catch (error) {
            // console.log(error)
            return false
        }
    },
    async getUserName({
        state,
        commit
    }, args) {
        try {
            const {
                data
            } = await API.graphql({
                query: getUserByEmail,
                variables: {
                    func: "getUserByEmail",
                    arguments: args
                },
                authMode: 'API_KEY'
            })
            if (data.getUserByEmail) return true
            else return false
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async updateUserPass({
        state,
        commit
    }, pass) {
        const {
            data
        } = await $unAuthUser.post(
            "/", {
                query: updateUserPassword,
                variables: {
                    username: state.user.username,
                    accessToken: state.user.signInUserSession.accessToken.jwtToken,
                    password: pass
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        if (data.data.updateUserPassword) return true;
        else return false;
    },
    async checkUserDetails({
        state,
        commit,
        dispatch
    }, userName) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: getUser,
                variables: {
                    username: userName
                }
            }, {
                headers: {
                    Authorization: state.user.signInUserSession.idToken.jwtToken
                }
            }
        );
        commit("setUser", user);
    },
    async checkSecureNowPhones({
        state,
        commit
    }) {
        const {
            data
        } = await $authUser.post(
            `/SecureNow/GetPhones`, null, {
                headers: {
                    Authorization: `Bearer ${
            state.user.signInUserSession.idToken.jwtToken
          }`
                }
            }
        );
        let phones = JSON.parse(data)["Phones"];
        commit("setSNPhones", phones)
    },
    async removeSecureNowPhone({
        state,
        commit
    }, phoneId) {
        const {
            data
        } = await $authUser.post(
            `/SecureNow/DeletePhone`, {
                PhoneId: phoneId
            }, {
                headers: {
                    Authorization: `Bearer ${
            state.user.signInUserSession.idToken.jwtToken
          }`
                }
            }
        );
        commit("removeSNPhone", phoneId)
    },
    async getDocumentTypes({
        state,
        commit
    }) {
        try {
            const {
                data
            } = await $authUser.get(
                `/myDocuments/getDocumentFilters`, {
                    headers: {
                        Authorization: `Bearer ${state.user.signInUserSession.idToken.jwtToken}`
                    }
                }
            )
            commit("setTypes", data)
            return true
        } catch (error) {
            console.log(error)
            return false
        }
        
    },
    async getAllAccounts({
        state,
        commit
    }) {
        try {
            const {
                data
            } = await $authUser.get(
                `/v3/myDocuments/accountList`, {
                    headers: {
                        Authorization: `Bearer ${state.user.signInUserSession.accessToken.jwtToken}`
                    }
                }
                );
            commit("setAccounts", data)
            return data
        } catch (error) {
            console.log(error)
        }
    },
    async searchAccount({
        state,
        commit
    }, accountInfo) {
        let { keyAccountNumber, filterId, filterType, startDate, endDate, taxYear } = accountInfo
        try {
            const {
                data
            } = await $authUser.post(
                `/v3/myDocuments/search`, {
                    keyAccountNumber,
                    filterId,
                    filterType,
                    startDate,
                    endDate,
                    taxYear
                },{
                    headers: {
                        Authorization: `Bearer ${state.user.signInUserSession.accessToken.jwtToken}`
                    }
                }
            );
            if (data.responseCode.value === "success") {
                commit("setUserStatements", data.documents)
                return true
            }
            else return false
        } catch (error) {
            console.error(error)
            return false
        }
    },
    async requestStatement({
        state,
        commit
    }, documentId) {
        try {
            const {
                data
            } = await $authUser.post(
                `/v3/myDocuments/request`, {
                    documentId
                },{
                    headers: {
                        Authorization: `Bearer ${state.user.signInUserSession.accessToken.jwtToken}`
                    }
                }
            );
            return data
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async addSecureNowPhone({
        state,
        commit
    }, phone) {
        const {
            data
        } = await $authUser.post(
            `/SecureNow/InsertPhone`, {
                Number: phone.full,
                CountryCode: phone.country,
                DefaultChallengeType: "5"
            }, {
                headers: {
                    Authorization: `Bearer ${
            state.user.signInUserSession.idToken.jwtToken
          }`
                }
            }
        );
        let newPhone = JSON.parse(data)
        if (newPhone.ErrorMessage === "IA: Phone already exists for user") {
            return
        } else {
            let id = JSON.parse(data)["Id"];
            if (id) {
                let lastPhone = {
                    PhoneID: `${id}`,
                    PhoneNumber: phone.full,
                    CountryCode: phone.country
                }
                commit("addSNPhone", lastPhone)
            }
        }
    },
    changeHub({ commit }, alex) {
        if (alex) {
            Hub.listen("auth", alex);
            commit("setHub", true)
        }
        else {
            Hub.remove("auth", alex);
            commit("setHub", false)
        }
    },
    async sendDetails({
        state
    }) {
        const {
            data
        } = await $axios.post(
            "/", {
                query: getUserInfo,
                variables: {
                    ssn: this.extraInfo.ssn
                }
            }, {
                headers: {
                    Authorization: this.user.signInUserSession.idToken.jwtToken
                }
            }
        );
    }
};

const mutations = {
    setUser(state, user) {
        state.user = user;
    },
    setUserDetails(state, userDetails) {
        state.userDetails = userDetails
    },
    setAdmin(state, bool) {
        state.admin = bool;
    },
    setSN(state, bool) {
        state.sn = bool;
    },
    setAccounts(state, accounts) {
        state.userAccounts = accounts
    },
    setUserAtts(state, atts) {
        state.user.attributes = atts;
    },
    setState(state, authState) {
        state.state = authState;
    },
    setConfirmed(state) {
        state.confirmed = true;
    },
    setPassword(state, password) {
        state.password = password
    },
    emptyPassword(state) {
        state.password = ""
    },
    setHub(state, hub) {
        state.hub = hub
    },
    setAuthError(state, error) {
        state.authError = error
    },
    setAccessToken(token) {
        state.user.signInUserSession.accessToken.jwtToken;
    },
    setIdToken(state, token) {
        state.user.signInUserSession.idToken.jwtToken = token;
    },
    setAnswer(state, answer) {
        state.answer = answer;
    },
    setLinks(state, links) {
        state.links = links;
    },
    setWexLinks(state, wexLinks) {
        state.wexLinks = wexLinks;
    },
    setIsNewUser(state, bool) {
        state.isNewUser = bool;
    },
    setIsNewPhone(state, bool) {
        state.isNewPhone = bool;
    },
    setMobileSignup(state, bool) {
        state.mobileSignup = bool;
    },
    setLastReview(state, bool) {
        state.lastReview = bool;
    },
    setReviewMode(state, bool) {
        state.reviewMode = bool;
    },
    setLoading(state, bool) {
        state.loading = bool;
    },
    setMainLoading(state, bool) {
        state.mainLoading = bool;
    },
    setFailed(state, bool) {
        state.failed = bool;
    },
    setAdminReset(state, bool) {
        state.adminReset = bool;
    },
    setSNAnswer(state, bool) {
        state.snAnswer = bool;
    },
    setError(state, bool) {
        state.snError = bool;
    },
    emptyUser(state) {
        state.user = "";
    },
    unsetConfirmed(state) {
        state.confirmed = false;
    },
    setBox(state, config) {
        state.box = config;
    },
    setPhones(state, phones) {
        state.phones = phones;
    },
    setResetUser(state, user) {
        state.resetUser = user;
    },
    setWex(state, bool) {
        state.wex = bool;
    },
    setRetirementBranded(state, bool) {
        state.retirementBranded = bool;
    },
    setMERSBranded(state, bool) {
        state.mersBranded = bool;
    },
    increaseStep(state) {
        state.step++
    },
    decreaseStep(state) {
        state.step--
    },
    setPrint(state, bool) {
        state.print = bool
    },
    setStraightSso(state, bool) {
        state.straightSso = bool;
    },
    setSNPhones(state, phones) {
        state.snPhones = phones;
    },
    addSNPhone(state, phone) {
        state.snPhones.push(phone)
    },
    removeSNPhone(state, phone) {
        let id = state.snPhones.findIndex(item => item.PhoneID === phone)
        state.snPhones.splice(id, 1)
    },
    updatePreference(state, prefs) {
        state.userAccounts[prefs.index].preferenceStatements = prefs.pref
    },
    setConfig(state, config) {
        state.config = config
    },
    setCurrentPath(state, path) {
        state.currentPath = path
    },
    setDocumentTypes(state, docTypes) {
        state.currDocTypes = docTypes
    },
    setAWSMfa(state, mfa) {
        state.awsMfa = mfa
    },
    setMfa(state, mfa) {
        state.mfa = mfa
    },
    setSNMfa(state, mfa) {
        state.snMfa = mfa
    },
    setVendor(state, vendor) {
        state.vendor = vendor
    },
    setTypes(state, types) {
        state.docTypes = types
    },
    setSystemAdmin(state, bool) {
        state.systemAdmin = bool
    },
    setUserStatements(state, statements) {
        state.userStatements = statements
    },
    emptyUserStatements(state) {
        state.userStatements = []
    },
    updateSinglePreference(state, pref) {
        state.userAccounts.forEach(item => {
            if (item.accountType === "401K") {
                item.deliveryPreference = pref
            }
        })
    },
    updateEPreference(state, pref) {
        let id = state.userAccounts.findIndex(item => item.keyAccountNumber === pref.index)
        state.userAccounts[id].deliveryPreference = pref.prop
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};